<template>
  <div class="w-full flex flex-row border-t border-secondary py-1 cursor-pointer" @click="goToProduct">
    <div class="w-auto flex flex-col pr-1">
      <div class="w-full flex justify-center md:justify-start">
        <img :src="productItem.image" :alt="productItemLang.name" class="w-auto max-w-32 h-auto max-h-32">
      </div>
    </div>
    <div class="w-full flex flex-col">
      <div>
        {{ productItem.code }} - {{ productItemLang.name }}
      </div>

      <div class="text-black flex text-justify truncate">
        {{ productItemLang.description }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopItemPreview",
  props: {
    productId: {
      type: Number,
      required: true
    }
  },
  computed: {
    productItem() {
      return this.$store.getters['Shop/getProductByIdFromShop'](this.productId);
    },
    productItemLang() {
      const locale = this.$i18n.locale;
      return this.productItem[locale];
    },
  },
  methods: {
    goToProduct() {
      //this.$router.push({ name: 'shop-item', params: { item_id: this.productId } });
    }
  }
}
</script>

<style scoped>

</style>
